import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';
import './BackButton.scss';

const BackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === '/') {
    return null;
  }

  const handleBack = () => {
    const historyIndex = window.history.state?.idx;

    if (typeof historyIndex === 'number' && historyIndex > 0) {
      navigate(-1);
      return;
    }

    navigate('/');
  };

  return (
    <div className='back_Button_Wrap'>
      <button type='button' className='back_Button' onClick={handleBack} aria-label='Go back to previous page'>
        <IoChevronBack aria-hidden='true' />
        <span>Back</span>
      </button>
    </div>
  );
};

export default BackButton;